import React,{useState} from "react";
import { Link } from "react-router-dom";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";
import { useNavigate } from "react-router-dom";

const Login = () => {

  const [inputData,setInputData]=useState({email:'',passcode:''});
  const navigate=useNavigate();

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});    
  }

  const handleSubmit=async(e)=>{
    e.preventDefault();
    const allinputData={email:inputData.email, passcode:inputData.passcode}
    let res=await axios.post(configData.SERVER_URL+'/loginEntry',allinputData);
    if(res.status===200){
      if(res.data.length>0){
        setTimeout(()=>{
          navigate('/orderlist', { state: { email: inputData.email } });
        },2000)
      } else{
        {alert('Invalid Email/Password')}
      }
    } else{
      alert('System Error');
    } 

  }

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Login</h1>
        <hr />
        <div class="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="card card-body">
              <div class="my-3">
                <label for="display-4">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  name="email"
                  placeholder="name@example.com"
                  value={inputData.email}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>
              <div class="my-3">
                <label for="floatingPassword display-4">Password</label>
                <input
                  type="password"
                  class="form-control"
                  id="passcode"
                  name="passcode"
                  placeholder="Password"
                  value={inputData.passcode}
                  onChange={(e)=>{handleInput(e)}}
                />
              </div>
              <div className="text-center">
                <button class="my-2 mx-auto btn btn-info" type="submit">
                  Login
                </button>
              </div>
              </div>
              
              <div className="my-3 d-flex flex-wrap gap-3">
                <Link to="/register" className="btn btn-outline-success btn-sm">
                <i className="fa fa-user-plus me-2"></i> Register
                </Link>

                <Link to="/ChangePassword" className="btn btn-outline-primary btn-sm">
                <i className="fa fa-key me-2"></i> Reset/Change Password
                </Link>
              </div>
              
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
